module.exports = __webpack_public_path__ + "static/media/banner2.ce0f3bd8.jpg";